import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { TOP_BAR } from '../mock/mock';

export default function TopBar() {
  return (
    <div className="hidden md:block bg-black/30 backdrop-blur-md text-white/85 text-[13px] py-2.5 border-b border-white/15 shadow-[0_1px_0_0_rgba(43,168,192,0.15)] relative z-50">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-7">
          <a href={`tel:${TOP_BAR.phone}`} className="flex items-center gap-2 hover:text-[#2BA8C0] transition-colors">
            <Phone className="w-3.5 h-3.5" />
            <span>{TOP_BAR.phone}</span>
          </a>
          <a href={`mailto:${TOP_BAR.email}`} className="flex items-center gap-2 hover:text-[#2BA8C0] transition-colors">
            <Mail className="w-3.5 h-3.5" />
            <span>{TOP_BAR.email}</span>
          </a>
        </div>
        <div className="flex items-center gap-7">
          <div className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" />
            <span>{TOP_BAR.location}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-3.5 h-3.5" />
            <span>{TOP_BAR.hours}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
